"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immer = _interopRequireDefault(require("immer"));

var _component = require("../component");

var _Alert = _interopRequireDefault(require("../Alert"));

var _styles = require("../styles");

var _uid = require("../utils/uid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Container =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Container, _PureComponent);

  function Container(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      messages: []
    };
    return _this;
  }

  var _proto = Container.prototype;

  _proto.addMessage = function addMessage(msg) {
    var _this2 = this;

    var id = (0, _uid.getUidStr)();
    this.setState((0, _immer.default)(function (state) {
      state.messages.push(Object.assign({
        id: id
      }, msg));
    }));

    if (msg.duration > 0) {
      setTimeout(function () {
        _this2.setState((0, _immer.default)(function (state) {
          state.messages.forEach(function (m) {
            if (m.id === id) {
              m.dismiss = true;
            }
          });
        }));
      }, msg.duration * 1000);
    }
  };

  _proto.removeMessage = function removeMessage(id) {
    var callback;
    var messages = this.state.messages.filter(function (m) {
      if (m.id !== id) return true;

      if (m.onClose) {
        callback = m.onClose;
      }

      return false;
    });

    if (messages.length === 0) {
      this.props.onDestory();
    } else {
      this.setState({
        messages: messages
      });
    }

    if (callback) callback();
  };

  _proto.closeEvent = function closeEvent(id, duration) {
    if (duration === 0) {
      return this.removeMessage.bind(this, id);
    }

    return undefined;
  };

  _proto.render = function render() {
    var _this3 = this;

    var messages = this.state.messages;
    return [messages.map(function (_ref) {
      var id = _ref.id,
          type = _ref.type,
          content = _ref.content,
          dismiss = _ref.dismiss,
          title = _ref.title,
          top = _ref.top,
          className = _ref.className;
      return _react.default.createElement("div", {
        key: id,
        className: (0, _styles.messageClass)('item') + " " + className
      }, _react.default.createElement(_Alert.default, {
        className: (0, _styles.messageClass)('msg'),
        dismiss: dismiss,
        onClose: _this3.removeMessage.bind(_this3, id),
        icon: true,
        iconSize: title ? 20 : 14,
        style: {
          top: top
        },
        type: type
      }, title && _react.default.createElement("h3", null, title), content));
    })];
  };

  return Container;
}(_component.PureComponent);

Container.propTypes = {
  onDestory: _propTypes.default.func.isRequired
};
Container.displayName = 'ShineoutMessage';
var _default = Container;
exports.default = _default;